module.exports = __webpack_public_path__ + "static/media/arrow-discover-more.7455adb5.svg";


//////////////////
// WEBPACK FOOTER
// /src/images/icons/arrow-discover-more.svg
// module id = 204
// module chunks = 0